import { Trans, useLingui } from '@lingui/react/macro';

import InlineText from '@/design_system/Typography/InlineText';
import IconAnalysis from '@/icons/Analysis.svg';
import { BaseNotification } from '@/layouts/App/Navbar/NotificationList/components/BaseNotification/BaseNotification';
import type { TNotificationOfType } from '@/models/notification';

export const PendingAnalysisNotification = ({
  notification,
}: {
  notification: TNotificationOfType<'pending_analysis'>;
}) => {
  const { t } = useLingui();

  return (
    <BaseNotification
      notificationLabel={
        notification.data?.onBehalfOfWorkshop
          ? t({
              id: 'notification.pending-analysis.label.on-behalf-workshop',
              message: `New workshop analysis to validate on behalf of workshop ${notification.data?.onBehalfOfWorkshop?.name} for request ${notification.request.reference}`,
            })
          : t({
              id: 'notification.pending-analysis.label',
              message: `New analysis to provide for request ${notification.request.reference}`,
            })
      }
      icon={<IconAnalysis />}
      type="new"
      notification={notification}
      notificationHeader={(color) =>
        notification.data?.onBehalfOfWorkshop ? (
          <Trans id="notification.pending-analysis.on-behalf-workshop">
            <InlineText weight="medium" color={color}>
              You
            </InlineText>{' '}
            have a new analysis to validate on behalf of workshop{' '}
            <InlineText weight="medium" color={color}>
              {notification.data?.onBehalfOfWorkshop?.name}
            </InlineText>
          </Trans>
        ) : (
          <Trans id="notification.pending-analysis">
            <InlineText weight="medium" color={color}>
              You
            </InlineText>{' '}
            have a new analysis to provide
          </Trans>
        )
      }
    />
  );
};
